module.exports = __webpack_public_path__ + "img/wbg.5bbefcc0.png";